export enum SIGNUP_STEP_IDS {
  ACCOUNT_CREATION = 'account-creation',
  STRUCTURE_SEARCH = 'structure-search',
  STRUCTURE_ATTACHEMENT = 'structure-attachement',
  STRUCTURE_IDENTIFICATION = 'identification',
  ACTIVITY = 'activite',
  VALIDATION = 'confirmation',
  COMPLETED = 'completed',
}
